export default __webpack_public_path__ + "static/media/1802.25040dcc.png";